import { Link } from 'react-router-dom';
import { Award, Users, AlertTriangle, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const features = [
  {
    icon: Award,
    title: "Centenary Projects",
    description: "Explore our special centenary initiatives celebrating 100 years of countryside protection.",
    link: "/centenary",
    color: "bg-cpre-new-yew",
  },
  {
    icon: Users,
    title: "Volunteer With Us",
    description: "Join our community of dedicated volunteers making a real difference to our countryside.",
    link: "/volunteering",
    color: "bg-cpre-autumn-leaf",
  },
  {
    icon: AlertTriangle,
    title: "Planning Alerts",
    description: "Stay informed about planning applications that could impact your local area.",
    link: "/planning",
    color: "bg-cpre-hill",
  },
];

export const FeaturePanels = () => {
  return (
    <section className="pt-8 pb-12 bg-cpre-pebble/30" data-testid="feature-panels">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 -mt-24 relative z-20">
          {features.map((feature, index) => (
            <Link key={feature.title} to={feature.link}>
              <Card 
                className="bg-white border-0 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group h-full"
                data-testid={`feature-card-${index}`}
              >
                <CardContent className="p-8">
                  <div className={`w-14 h-14 ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <feature.icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    {feature.description}
                  </p>
                  <span className="inline-flex items-center text-cpre-new-yew font-medium text-sm group-hover:gap-3 gap-2 transition-all duration-200">
                    Learn more
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
